const ScheduleData = [
     {
        id: 1,
        itemType: 'NeetExam',
        days: '10 Days Left',
        name: 'NEET Semi Grand',
        totalStudents: '23.5k',
        dicount: '95%',
        date: '02-02-2020',
        likes: '2.5k'
    },
     {
        id: 2,
        itemType: 'NeetSemiGrand',
        days: '6 Days Left',
        name: 'NEET Grand',
        totalStudents: '23.5k',
        dicount: '95%',
        date: '02-02-2020',
        likes: '2.5k'
    },
    {
        id: 3,
        itemType: 'NeetExam',
        days: '7 Days Left',
        name: 'NEET Comulative',
        totalStudents: '23.5k',
        dicount: '95%',
        date: '02-02-2020',
        likes: '2.5k'
    },
    {
        id: 4,
        itemType: 'NeetSemiGrand',
        days: '15 Days Left',
        name: 'NEET Semi Grand',
        totalStudents: '23.5k',
        dicount: '95%',
        date: '02-02-2020',
        likes: '2.5k'
    }
]
export default ScheduleData;
